import { render, staticRenderFns } from "./soloPkRanking.vue?vue&type=template&id=5c3d4fac&scoped=true"
import script from "./soloPkRanking.vue?vue&type=script&lang=ts"
export * from "./soloPkRanking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d4fac",
  null
  
)

export default component.exports